import React, { useEffect, useState } from 'react';
import '../LegalPages.css';

function EliminacionDatos() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    plataforma: '',
    descripcion: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Set page title
    document.title = 'Solicitud de Eliminación de Datos | Agencia La Botica';
    
    // Add noindex meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'noindex, nofollow';

    return () => {
      if (metaRobots) {
        metaRobots.content = 'index, follow';
      }
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // Send to backend API
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/data-deletion`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        throw new Error('Error al enviar la solicitud');
      }
    } catch (err) {
      // Fallback to mailto
      const subject = encodeURIComponent('Solicitud de Eliminación de Datos');
      const body = encodeURIComponent(
        `Nombre: ${formData.nombre}\n` +
        `Email: ${formData.email}\n` +
        `Plataforma: ${formData.plataforma}\n` +
        `Descripción: ${formData.descripcion}`
      );
      window.location.href = `mailto:pablo@agencialabotica.cl?subject=${subject}&body=${body}`;
      setSubmitted(true);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <a href="/" className="legal-logo">
            <img src="/logo-labotica.svg" alt="Agencia La Botica" />
          </a>
        </header>

        <main className="legal-content">
          <h1>Solicitud de Eliminación de Datos</h1>
          <p className="legal-updated">Última actualización: Febrero 2026</p>

          <section>
            <h2>Tu Derecho a la Eliminación de Datos</h2>
            <p>
              De acuerdo con la legislación chilena sobre protección de datos personales 
              (Ley N° 19.628), tienes derecho a solicitar la eliminación de tus datos personales 
              que hayamos recopilado a través de nuestro sitio web o plataformas conectadas.
            </p>
            <p>
              Esto incluye datos recopilados mediante:
            </p>
            <ul>
              <li>Nuestro sitio web agencialabotica.cl</li>
              <li>Interacciones en Facebook e Instagram (Meta)</li>
              <li>LinkedIn</li>
              <li>Otras plataformas donde hayamos interactuado contigo</li>
            </ul>
          </section>

          <section>
            <h2>Cómo Funciona</h2>
            <p>
              Una vez que recibamos tu solicitud, la procesaremos en un plazo máximo de 
              <strong> 30 días hábiles</strong>. Te notificaremos por correo electrónico 
              cuando la eliminación se haya completado.
            </p>
            <p>
              Ten en cuenta que algunos datos pueden ser necesarios para cumplir con 
              obligaciones legales o contractuales, en cuyo caso te informaremos sobre 
              las limitaciones aplicables.
            </p>
          </section>

          {!submitted ? (
            <section className="form-section">
              <h2>Formulario de Solicitud</h2>
              <p>Completa el siguiente formulario para solicitar la eliminación de tus datos:</p>

              {error && <p className="error-message">{error}</p>}

              <form onSubmit={handleSubmit} className="deletion-form">
                <div className="form-group">
                  <label htmlFor="nombre">Nombre completo *</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Correo electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="tu@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="plataforma">Plataforma donde interactuaste *</label>
                  <select
                    id="plataforma"
                    name="plataforma"
                    value={formData.plataforma}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona una opción</option>
                    <option value="Sitio web">Sitio web (agencialabotica.cl)</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Instagram">Instagram</option>
                    <option value="LinkedIn">LinkedIn</option>
                    <option value="Otra">Otra plataforma</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="descripcion">Descripción de la solicitud *</label>
                  <textarea
                    id="descripcion"
                    name="descripcion"
                    value={formData.descripcion}
                    onChange={handleChange}
                    required
                    rows="4"
                    placeholder="Describe qué datos deseas eliminar y cualquier información adicional que nos ayude a procesar tu solicitud..."
                  />
                </div>

                <button type="submit" className="submit-button">
                  Enviar Solicitud
                </button>
              </form>
            </section>
          ) : (
            <section className="success-section">
              <h2>¡Solicitud Enviada!</h2>
              <div className="success-message">
                <p>
                  Hemos recibido tu solicitud de eliminación de datos. 
                  La procesaremos en un plazo máximo de <strong>30 días hábiles</strong>.
                </p>
                <p>
                  Te enviaremos una confirmación a <strong>{formData.email}</strong> 
                  cuando la eliminación se haya completado.
                </p>
                <p>
                  Si tienes alguna pregunta, puedes contactarnos en{' '}
                  <a href="mailto:pablo@agencialabotica.cl">pablo@agencialabotica.cl</a>
                </p>
              </div>
            </section>
          )}

          <section>
            <h2>Contacto</h2>
            <p>
              Si tienes preguntas sobre el proceso de eliminación de datos o necesitas 
              asistencia adicional, puedes contactarnos directamente:
            </p>
            <p>
              <strong>Agencia de Publicidad La Botica Limitada</strong><br />
              Santiago de Chile<br />
              Email: <a href="mailto:pablo@agencialabotica.cl">pablo@agencialabotica.cl</a>
            </p>
          </section>
        </main>

        <footer className="legal-footer">
          <p>© 2026 Agencia La Botica — Santiago, Chile</p>
        </footer>
      </div>
    </div>
  );
}

export default EliminacionDatos;
